// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5257": "88225f65","5545": "20927b2f","7967": "0bea4963","8881": "3369f087",}[chunkId] + ".css"
}